








































import Vue from "vue";
import { coordinates } from "common";
import TravelRequestForm from "./TravelRequestForm.vue";
// import RouteFinder from "./RouteFinder.vue";

export default Vue.extend({
    //name: "HelloWorld",
    props: {
        msg: String,
    },
    data() {
        return {
            //someplace: coordinates("0123:0080:0246:0079")
        };
    },
    components: {
        TravelRequestForm,
        // RouteFinder,
    },
});
